import { useAuth as useAuthContext } from '@contexts/AuthContext';

/**
 * useAuth — convenience wrapper around AuthContext
 * Adds permission checking helpers
 */
export default function useAuth() {
  const auth = useAuthContext();

  const hasPermission = (permission) => auth.permissions.includes(permission);
  const isEmployee = auth.userType === 'employee';
  const isCustomer = auth.userType === 'customer';
  const isGuest = !auth.isAuthenticated;

  return { ...auth, hasPermission, isEmployee, isCustomer, isGuest };
}
